import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

const StyledSlide = styled("div")(({ isMobile }) => ({
  position: "relative",
  maxHeight: isMobile ? 199 : 430,
  maxWidth: isMobile ? 353 : 765,
  aspectRatio: "16/9",
  borderRadius: 8,
  overflow: "hidden",
  zIndex: 0,
}));

const Slide = ({ isMobile, children }) => {
  return (
    <StyledSlide isMobile={isMobile} data-testid="slide-component">
      {children}
    </StyledSlide>
  );
};

Slide.propTypes = {
  isMobile: PropTypes.bool,
  children: PropTypes.node,
};

export default Slide;
